// scroll offset -  must be equal to $h-topbar
var offset = 115;

window.addEventListener("DOMContentLoaded", function () {
  var body = document.querySelector('body');
  if (body.classList.contains('i4-template--edit-mode')) {
    offset += 50; // adjust offset for i4 admin topbar
  }

  // initCRMForm();
  initVueCRMForm();

  // mega menu
  initMenuButton();
  initSearchButton();
  addClearButtonToAlgoliaAutocomplete();
  addAlgoliaSearchEnterEvent();
  hideHiddenNavigationElements();

  initAnchorScrollOffset();
  adjustVehicleTextbox();
  initShowMore();
  initOccasionen();
  initSvgSlider();

  // hauszeitung register copy article link - events
  initHauszeitung();

  initConfiguratorIFrameResizer();
});

function initAnchorScrollOffset() {
  $('a[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 400, 'swing');
        return false;
      }
    }
  });
}

// mega menu start
function initMenuButton() {
  const menuButton = $('#menu-toggle');
  if (menuButton && menuButton.length > 0) {
    $(menuButton).bind('click', function () {
      $(this).toggleClass('open');
      toggleNavigation();
      registerNavigationElementToggleEvents();
      registerSpinnerForNavigation();
    });
  }
}

function initSearchButton() {
  const searchButton = $('#search_button_mobile');
  const searchField = $('.i4-site-search');
  if (searchButton.length < 1 || searchField.lenght < 1) {
    return;
  }
  $(searchButton).bind('click', function () {
    $(searchField).toggleClass('visible');
  });

}

function toggleNavigation() {
  $('#navigation').toggleClass('open');
  $('body').toggleClass('i4-page--navigation');

  $('.c-navigation__element--level-3.c-navigation__element--active').addClass('open');
}

let navigationFirstLevelElements = [];

function registerNavigationElementToggleEvents() {
  navigationFirstLevelElements = $('#navigation .c-navigation__element--level-3');
  const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  if (navigationFirstLevelElements.length < 1 || viewportWidth > 415) {
    return;
  }

  // console.log('navigationFirstLevelElements', navigationFirstLevelElements);

  $(navigationFirstLevelElements).each((index, element) => {
    $(element).on('click touchend', handleNavigationFirstLevelClick);
  });
}

function registerSpinnerForNavigation() {
  const navigationLinks = $('#navigation .c-navigation__element--level-4 a');
  $(navigationLinks).each((index, element) => {
    $(element).on('click touchend', showSpinnerAndNavigate);
  });
}

function showSpinnerAndNavigate(event) {
  $('.spinner').show();
}

function handleNavigationFirstLevelClick(event) {
  if ($(this).hasClass('open')) {
    return;
  }

  event.preventDefault();
  $(navigationFirstLevelElements).removeClass('open');
  $(this).addClass('open');
}

function addClearButtonToAlgoliaAutocomplete() {
  const autocompleteInput = $('.c-search-algolia--autocomplete__input');
  if (autocompleteInput.length < 1) {
    return;
  }

  const button = '<button class="c-search-algolia--autocomplete__clear" type="reset"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg></button>';
  $(autocompleteInput).after(button);

  const clearButton = $('.c-search-algolia--autocomplete__clear');
  $(clearButton).on('click', function() {
    $(autocompleteInput).val('');
    $('.aa-dropdown-menu').hide();
    $(this).removeClass('visible');
  });

  $('.c-search-algolia--autocomplete__input').on('keyup', function() {
    const elementValue = $(this).val();
    if (elementValue.length < 1) {
      $(clearButton).removeClass('visible');
    } else {
      $(clearButton).addClass('visible');
    }
  });
}

function addAlgoliaSearchEnterEvent() {
  const autocompleteInput = $('.c-search-algolia--autocomplete__input');
  if (autocompleteInput.length < 1) {
    return;
  }

  $(autocompleteInput).on('keyup', function (e) {
    const searchString = $(this).val();
    if (searchString.length > 2 && (e.key === 'Enter' || e.keyCode === 13)) {
      $('#all_search_results').click();
    }
  });
}

function hideHiddenNavigationElements() {
  const navigationEditMode = $('.i4-template--edit-mode #navigation');
  if (navigationEditMode.length < 1) {
    return;
  }

  // if it has a status icon, the navigation element should not be visible
  // temporary fix, because navigation container setting "editable" is not working
  const navigationElementsToHide = $('.c-navigation__element-status-icon');
  navigationElementsToHide.each((index, element) => {
    $(element).parents('.c-navigation__element').first().hide();
  });
}
// mega menu end

function adjustVehicleTextbox() {
  var elements = document.querySelectorAll('.c-composition-teaser_box_text');
  for (let i = 0; i < elements.length; i++) {
    elements[i].parentNode.style.flexBasis = '100%';
  }
}

function initShowMore() {
  const isEditMode = $('.i4-template--edit-mode').length > 0;

  if (!isEditMode) {
    const element = $('.scrolldown__trigger');
    const topBarHeight = $('.i4-site-topbar').height();

    if (element) {
      element.on('click', () => {
        $([document.documentElement, document.body]).animate({
          scrollTop: $('.scrolldown__target').offset().top - topBarHeight,
        }, 750);
      });
    }
  }
}


// occasions-tool
const formIdentifier = '[name="form_212571"]';

function initOccasionen() {
  const occasionen = $('.c-composition-occasion__action');

  if (occasionen.length > 0) {
    $(formIdentifier).hide();

    occasionen.each((index, occasione) => {
      $(occasione).on('click', occasionenActionEvent);
    });
  }
}

function attachBackButton() {
  const button = $(formIdentifier + ' .form-element--submit button.occasion-back');
  if (button.length === 0) {
    const buttonContainer = $(formIdentifier + ' .form-element--submit');
    $(buttonContainer).css('position', 'relative');

    $(buttonContainer).prepend('<button class="button button--primary occasion-back" onclick="occasionGoBack(event)"><svg><title>Title</title><use xlink:href="#svg-sprite-admin-icon-back" /></svg></button>');
  }
}

function occasionGoBack(event) {
  event.preventDefault();
  $(formIdentifier).hide();
  $('.c-composition-occasion').fadeIn();

  $([document.documentElement, document.body]).animate({
    scrollTop: $('.c-composition-occasion').first().offset().top - 100
  }, 0);
}

function occasionenActionEvent(event) {
  event.preventDefault();

  // get the chassis no
  const chassisNo = $(event.target).attr('data-chassisno');
  const title = $(event.target).attr('data-title');

  // hide the occassion-composition
  $('.c-composition-occasion').hide();

  const chassisNoFormField = $(formIdentifier + ' #form_element_212605');
  console.log('chassisNoFormField', chassisNoFormField);
  $(chassisNoFormField).val(chassisNo).css({
    'opacity': 0
  });

  // get the title element and the span where the cassis no will be placed
  const formTitle = $(formIdentifier + ' .c-text h1');
  let chassisNoSpan = $(formIdentifier + ' .c-text h1 span');

  if (chassisNoSpan.length === 0) {
    // if there's no span yet, create and get the created element again
    formTitle.append('<span>');
    chassisNoSpan = $(formIdentifier + ' .c-text h1 span');
  }

  $(chassisNoSpan).empty();

  // fill the content in the span in the title with the chassis no
  $(chassisNoSpan).append('<br>' + title + '&nbsp;&nbsp;#' + chassisNo);

  attachBackButton();

  // show the form
  $(formIdentifier).fadeIn();

  const parentAggregator = $(formIdentifier).parents('.c-aggregator__item--form').first();
  $(parentAggregator).css('opacity', 1);

  // scroll the form into the viewport
  $([document.documentElement, document.body]).animate({
    scrollTop: $(formIdentifier).offset().top - 100
  }, 1000);
}

function refactorHauszeitungImages(articleIndex, element) {
  const imageContainers = $(element).find('.c-hauszeitung-article__image');
  $(imageContainers).each((index, container) => {
    const images = $(container).find('img');
    $(images).each((index, image) => {
      const imageSrc = $(image)[0].dataset.src;
      let legend = $(image).closest('.c-hauszeitung-article__image').find('.c-hauszeitung-article__image--legend').text();
      let caption = '';
      if (legend.length > 0) {
        legend = $.trim(legend);
        caption = ' data-caption="' + legend + '"';
        // console.log('caption', caption);
      }
      $(image).remove();
      $(container).append('<a href="' + imageSrc + '" data-fancybox="gallery-' + articleIndex + '"' + caption + '><img src="' + imageSrc + '" alt="" /></a>');
    });
  });
}

function initHauszeitungFancybox() {
  const hauszeitungArticles = $('.c-hauszeitung-article');
  const isEditMode = $('.i4-template--edit-mode').length > 0;
  if (hauszeitungArticles.length < 1 || isEditMode) {
    return;
  }


  $(hauszeitungArticles).each((articleIndex, element) => {
    refactorHauszeitungImages(articleIndex, element);
  });
}

function initHauszeitung() {
  // const copyButtons = document.getElementsByClassName('c-hauszeitung-article__copy-link-button');
  // if (copyButtons.length > 0) {
  //   const copyButtonArray = [...copyButtons]; // converts HTMLCollection to array
  //   copyButtonArray.forEach(button => {
  //     button.addEventListener('click', onClickCopyButton);
  //   });
  // }

  initHauszeitungFancybox();
}

function onClickCopyButton(event) {
  event.preventDefault();
  const href = event.target.href;
  navigator.clipboard.writeText(href).then(() => {
    alert('✅');
  }, (err) => {
    console.error('Async: Could not copy text: ', err);
  });
}

function initSvgSlider() {
  const svgSlider = document.querySelector('.c-embed .kyburz-svg-slider');
  if (svgSlider) {
    const embed = svgSlider.closest('.c-embed');
    embed.style.paddingBottom = '72.2%';
    try {
      $(svgSlider).slick({
        autoplaySpeed: 5000,
        dots: true,
        arrows: false,
        autoplay: true,
        fade: true,
        speed: 1000
      });
    } catch(e) {
      console.log(e);
    }
  }
}

function initCRMForm() {
  const crmForm = $('#crmWebToEntityForm');
  if (crmForm) {
    const parentEmbed = $(crmForm).closest('.c-embed');
    $(parentEmbed).addClass('c-embed--crmform');

    setTimeout(() => {
      $(parentEmbed).addClass('visible');
    }, 1000);
  }
}

function initVueCRMForm() {
  const crmForm = $('#kyburz-crm-form');
  if (crmForm) {
    const parentEmbed = $(crmForm).closest('.c-embed');
    $(parentEmbed).addClass('c-embed--crmform');

    setTimeout(() => {
      $(parentEmbed).addClass('visible');
    }, 1000);
  }
}

function initConfiguratorIFrameResizer() {
  if ($('.i4-template--configurator').length < 1) {
    return;
  }
  // https://github.com/davidjbradshaw/iframe-resizer
  iFrameResize({
    // log: true,
    heightCalculationMethod: 'lowestElement',
    onMessage: function (messageData) {
      // alert(messageData.message);
      if (messageData.message === 'scrollup') {
        setTimeout(() => {
          // console.log('%c scrollup ', 'background-color: #bada55; color: black;');
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }, 1000);
      }
    },
  }, '.c-embed iframe');
}
